import { SimpleObjectInterface } from '@thewhite/react-global-module/lib/interfaces';
import * as t from 'io-ts';
import BASE_STATUS from '../../Global/enums/baseStatus';

export const UserProfileDateType = t.interface({
    id: t.string,
    name: t.union([t.string, t.null, t.undefined]),
    status: t.union([t.string, t.null, t.undefined]),
});

export interface UserProfileDateDto extends t.TypeOf<typeof UserProfileDateType> {
}

class UserProfileDate {
    id: string;
    name: string | null;
    status: SimpleObjectInterface | null;

    constructor(params: UserProfileDateDto) {
        this.id = params.id;
        this.status = params.status
            ? BASE_STATUS[params.status]
            : null;
        this.name = params.name ?? null;
    }
}

export default UserProfileDate;
